import { Box, Button, Heading, Text } from '@betterment/samba-react';

export const ReclaimSignature: React.FC<React.PropsWithChildren<{ onReclaimSignature: VoidFunction }>> = ({
  onReclaimSignature,
}) => {
  return (
    <Box css={{ p: 'space.300', borderStyle: 'solid', borderWidth: 'thin', borderColor: 'border.weak' }}>
      <Box css={{ display: 'flex' }}>
        <Box css={{ flexGrow: '1' }}>
          <Heading variant="title100">Are you the contract signer?</Heading>
          <Text>If so, you may also sign the document on this page.</Text>
        </Box>
        <Button onClick={() => onReclaimSignature()}>Sign document here</Button>
      </Box>
    </Box>
  );
};
